
























































































































































































































































































































import cloneDeep from "lodash/cloneDeep";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  minLength,
  sameAs
} from "vuelidate/lib/validators";
import { getFieldError } from "@/core/tools/forms/get_field_error";

import { STORE_KEY, store } from "./_store";

import TitleBar from "@/components/Elements/TitleBar.vue";
import ProductCombobox from "@/components/Controls/ProductCombobox.vue";
import ProductContainerCombobox from "@/components/Controls/ProductContainerCombobox.vue";
import moment from "moment";

@Component({
  mixins: [validationMixin],
  computed: {
    ...mapState("ubic", ["token", "actor"]),
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "filter",
      "catalog",
      "client",
      "holydays",

      "documents",
      "lastMeta",
      "asyncErrors",
      "hasAsyncError",
      "asyncValidationLoading"
    ]),
    ...mapGetters(STORE_KEY, ["total"])
  },
  methods: {
    getFieldError,
    ...mapActions(STORE_KEY, ["addDocument", "removeDocument", "addProduct"])
  },
  validations() {
    const rules: any = {
      delivery_point_id: { required },
      expected_delivery_date: { required },
      counterparty_id: { required }
    };

    return {
      documents: {
        $each: rules
      }
    };
  },
  components: {
    TitleBar,
    ProductCombobox,
    ProductContainerCombobox
  }
})
export default class OrdersNew extends Vue {
  opened: any[] = [];
  disabled_week_days: any = {};
  minDay: any = {};
  minDayBorders: any = {};
  documents!: any[];
  lastDeliveryPoints: any[] = [];

  get titleStack() {
    return ["Новый заказ"];
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null;
  }

  saveForm() {
    this.$v.documents.$touch();
    if (!this.$v.documents.$error) {
      const null_deals_count = this.documents.reduce((acc: number, dp: any) => {
        const _products = dp.products.filter((item: any) => {
          return item.container_quantity;
        });
        if (!_products.length) {
          acc += 1;
        }
        return acc;
      }, 0);
      if (null_deals_count) {
        this.$buefy.dialog.alert({
          title: "Вы не выбрали продукты в заказе.",
          message: `В заказе не выбран ни одни продукт. Выберите хотя бы один продукт или удалите заявку на точку.`,
          confirmText: "Понятно"
        });
      } else {
        const delivery_point_ids: any[] = this.documents.map(
          (item: any, index: number) => {
            return item.delivery_point_id;
          }
        );
        this.$store
          .dispatch(`${STORE_KEY}/getDeliveryDates`, { delivery_point_ids })
          .then(res => {
            console.log(res);
            const no_allowed_dates: any[] = this.documents
              .map((item: any, idx: number) => {
                console.log(moment(item.expected_delivery_date), res[idx]);
                if (moment(item.expected_delivery_date).isBefore(res[idx])) {
                  return { idx, date: item.expected_delivery_date };
                }
              })
              .filter((item: any) => item);
            if (no_allowed_dates.length) {
              const date = moment(no_allowed_dates[0].date).format(
                "DD.MM.YYYY"
              );
              this.$buefy.dialog.alert({
                title: "Дата не доступна для заказа",
                message: `Дата ${date} более не доступна для заказа. Прошу выбрать другую`,
                confirmText: "Понятно"
              });
              this.changeValue(
                no_allowed_dates[0].idx,
                "expected_delivery_date",
                null
              );
              this.onDeliveryPoint(
                no_allowed_dates[0].idx,
                this.lastDeliveryPoints[no_allowed_dates[0].idx]
              );
            } else {
              this.$store.dispatch(`${STORE_KEY}/saveForm`).then(() => {
                this.$router.replace({
                  name: "orders"
                });
              });
            }
          });
      }
    }
  }

  get defaultSort() {
    return [
      this.$route.query.sortField || "name",
      this.$route.query.sortDirection || "asc"
    ];
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // this.checkFilterChange();
    this.handleParamsChange();
  }

  public beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  setClient() {
    this.$store.dispatch(`${STORE_KEY}/saveClient`, {});
  }

  changeValue(index: number, field: string, value: any) {
    this.$store
      .dispatch(`${STORE_KEY}/changeValue`, {
        index,
        field,
        newValue: value
      })
      .then(() => {
        this.$store.dispatch(`${STORE_KEY}/prepareCatalog`, {}).then(() => {
          this.$v.documents.$touch();
        });
      });
  }

  changeCatalogValue(index: number, idx: number, field: string, value: any) {
    console.log(index, idx, field, value);
    this.$store
      .dispatch(`${STORE_KEY}/changeCatalogValue`, {
        index,
        idx,
        field,
        newValue: value
      })
      .then(() => {
        // this.$v.documents.$touch()
      });
  }

  changeProductValue(
    index: number,
    idx: number,
    field: string,
    value: any,
    base_weight: number
  ) {
    // if (field === "unit_quantity") {
    //   value = value / base_weight;
    // }
    console.log(index, idx, field, value);
    this.$store
      .dispatch(`${STORE_KEY}/changeProductValue`, {
        index,
        idx,
        field,
        newValue: value
      })
      .then(() => {
        this.$v.documents.$touch();
      });
  }
  onProductContainer(index: number, idx: number, field: string, value: any) {
    console.log(index, idx, field, value);
    this.$store.dispatch(`${STORE_KEY}/changeProductValue`, {
      index,
      idx,
      field: "base_price",
      newValue: parseFloat(value.price)
    });
    this.$store.dispatch(`${STORE_KEY}/changeProductValue`, {
      index,
      idx,
      field: "base_weight",
      newValue: parseFloat(value.weight)
    });
  }

  onDeliveryPoint(index: number, $event: any) {
    this.lastDeliveryPoints[index] = $event;
    this.$store
      .dispatch(`${STORE_KEY}/changeValue`, {
        index,
        field: "deal_client_id",
        newValue: $event.client_id
      })
      .then(() => {
        this.$store
          .dispatch(`${STORE_KEY}/prepareCatalog`, {
            client_id: $event.client_id
          })
          .then(() => {
            this.changeValue(index, "counterparty_id", $event.counterparty_id);
            this.changeValue(index, "deal_client_name", $event.client_name);
            this.changeValue(
              index,
              "delivery_zone_id",
              $event.delivery_zone_id
            );
            this.$v.documents.$touch();
          })
          .catch((err: any) => {
            console.log(err);
          });
      });
    this.$store.dispatch(`${STORE_KEY}/setYear`, {
      delivery_point_id: $event.id,
      delivery_zone_id: $event.delivery_zone_id
    });
    console.log("dp => ", $event);
    this.$store
      .dispatch(`${STORE_KEY}/getDeliveryDate`, {
        delivery_point_id: $event.id
      })
      .then(minDay => {
        this.minDay[index] = minDay;
      })
      .catch((err: any) => {
        console.log(err);
      });
    const _now = moment().weekday();
    const week_days: any = $event.week_days.filter((item: any) => {
      return item.delivery_point_id == $event.id;
    });
    this.disabled_week_days[index] = (!week_days.length
      ? $event.week_days
      : week_days
    ).reduce((acc: any[], item: any) => {
      if (!item.is_allow) {
        acc.push(item.week_day < 7 ? item.week_day : 0);
      }
      return acc;
    }, []);
    this.minDay[index] = $event.week_days
      .filter((item: any) => {
        return _now == item.week_day - 1;
      })
      .map((item: any) => {
        if (!item.time) {
          item.time = "23:59:59";
        }
        const _day = item.time
          ? moment(item.time, "HH:mm:ss")
              .utc()
              .local()
          : null;
        this.minDayBorders[index] = _day;
        return moment()
          .startOf("day")
          .add(
            moment()
              .utc()
              .local()
              .isAfter(_day)
              ? 2
              : 1,
            "day"
          )
          .toDate();
      })[0];
  }

  // ---------------------------------------------------------------------------

  @Watch("$route.query")
  public handleParamsChange() {
    if (this.$route.query.copy) {
      this.$store.dispatch(`${STORE_KEY}/loadDeal`, this.$route.query);
    } else {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.$route.query);
    }
  }
}
